import { createContainer, PlatformReady } from "@inter-ikea-space-platform/container";
import { roomExperiences } from "@inter-ikea-space-platform/range";

import { config } from "./config";
import { deprecatedBathroomExperience, functionalPackages, rangePackages } from "./experiences";

const { env, kompisProxyUrl: proxyUrl } = config.settings;

createContainer({
  config,
  rangePackages: rangePackages({ env, proxyUrl }),
  roomExperiences: [
    ...roomExperiences({ env, proxyUrl }),
    deprecatedBathroomExperience({ env, proxyUrl }),
  ],
  functionalPackages: functionalPackages({ env, proxyUrl }),
  testPackages: [],
  onPlatformReady: (props: PlatformReady) => {
    const platformDebuggerParam = new URLSearchParams(window.location.search).get(
      "platformDebugger",
    );
    if (env !== "prod" || platformDebuggerParam === "true" || Boolean("Cypress" in window)) {
      const { core } = props.coreClient;
      import("@inter-ikea-space-platform/platform-debugger")
        .then(({ PlatformDebugger }) => {
          new PlatformDebugger(core).attach();
        })
        .catch(() => {});
    }
  },
});
